<template>
  <div id="faq">
    <div class="page">
    <header class="page__header">
      <router-link to="/">
        <img class="logo" src="../assets/images/logo.png" alt="Heldengame" />
      </router-link>
      <router-link to="/">
        <span>Terug naar home</span>
      </router-link>
      <h1>FAQ</h1>
    </header>
      <dl>
        <template v-for="(item, index) in content">
          <dt :key="`q${index}`">{{ item.question }}</dt>
          <dd :key="`a${index}`">{{ item.answer }}</dd>
        </template>
      </dl>
    </div>
  </div>
</template>

<script>
import content from '@/content/faq.json'

export default {
  name: 'Faq',
  data () {
    return {
      content
    }
  }
}
</script>

<style scoped lang="scss">
#faq {
  dl, dt, dd {
    margin: 0;
    padding: 0;
    font-size: 2.1rem;
  }

  dt {
    margin-bottom: .9rem;
    font-weight: 700;
    color: $color-red;
  }

  dd {
    margin-bottom: 3rem;
  }
}

.page {
  width: 100%;
  max-width: 76.8rem;
  margin: 0 auto;
}

.page__header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  img {
    position: absolute;
    display: block;
    top: 0;
    left: -6rem;
    width: 30rem;
    height: auto;
  }

  h1 {
    margin: 12rem 0;
    font-size: 6.0rem;
    text-align: center;
  }

  span {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    padding: 1.5rem;
    font-size: 2.1rem;
    font-weight: 400;
    text-transform: uppercase;
    transition: color 200ms;
    color: $color-black;

    &:hover {
      color: $color-green;
    }

    @include breakpoint(min-width, $screen-hd) {
      font-size: 2.4rem;
    }
  }
}

</style>
